// extracted by mini-css-extract-plugin
export default {"heading":"rangeDateModal_heading__VaDTW","TipAmount":"rangeDateModal_TipAmount__SspPC","FooterModal":"rangeDateModal_FooterModal__cZLOU"};